import { TFunction } from 'i18next';
import {
    DefaultLogger,
    OutlookActions,
    GeException,
    Container,
} from '../infrastructure';
import { GeApi, GlobalServiceInterface } from "./GeApi";
import { AppointmentOutlookActions } from "../infrastructure/AppointmentOutlookActions";
import { ApmBase } from '@elastic/apm-rum';
import { ApiInstanceError } from '../infrastructure/utils';

export type SendSecureResult = {
    allowEvent: boolean,
    apiInstance?: GeApi
};

/**
 * This class implements the onSend business logic that processes the message details and allows a secure message to be transmitted.
 */
export default class OnSendHook {
    /**
     * This is the entry point callback of the class.
     */
    public async onSend(t: TFunction, container: Container, apm: ApmBase): Promise<SendSecureResult> {
        const logger = new DefaultLogger();
        const itemType = Office.context.mailbox.item.itemType;
        const outlookActions = itemType === Office.MailboxEnums.ItemType.Message ? new OutlookActions(logger, apm) : new AppointmentOutlookActions(logger, apm); 
        const globalService: GlobalServiceInterface = {
            logger,
            outlookActions,
            t,
            geApi: null,
            apm
        };

        try {        
            globalService.outlookActions.init();
            globalService.geApi = new GeApi(globalService, container, itemType as Office.MailboxEnums.ItemType);
            const state = globalService.geApi.getState();
            localStorage.setItem("GeApiState", JSON.stringify(state));
            // if (await this.showEngineeringDialogIfSpecialSubject(globalService)) {
            //     return {
            //         allowEvent: false
            //     };
            // }
            const sendAction = await globalService.geApi.sendSecure();
            return {
                allowEvent: sendAction != GeApi.SendSecureResult.DONT_SEND,
                apiInstance: globalService.geApi,
            };
        }
        catch (e) {
            GeException.logException(globalService.logger, e);
            const state = JSON.parse(localStorage.getItem("GeApiState"));

            // we need the api instance thrown as well, to be able to trigger audits in the catch case as well in index.tsx.
            const apiInstance = globalService.geApi;
            // update class state
            apiInstance.setState(state);
            throw new ApiInstanceError(e, apiInstance);
        }
    }

    // /**
    //  * Shows the engineering screen if it matches the special keyword
    //  * @param globalService
    //  */
    // private async showEngineeringDialogIfSpecialSubject(globalService: GlobalServiceInterface): Promise<boolean> {
    //     const subject = await globalService.outlookActions.getSubjectFromOutlook();

    //     if (subject.indexOf('[#eng#]') != -1) {
    //         const deployment = getUrlParameter('deployment');
    //         const env = getUrlParameter('env');

    //         return new Promise<boolean>(async (resolve) => {
    //             const dialogHandle = await globalService.outlookActions.showDialog(`https://${window.location.host}/eng?deployment=${deployment}&env=${env}`, 70, 70, () => {
    //                 dialogHandle.close();

    //                 resolve(true);
    //             });
    //         });
    //     }

    //     return false;
    // }
}